module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-results-filters-collapse-box collapse in"
  }, [_c('div', {
    staticClass: "ibox-results-filters"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Keywords")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Commodity")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.commodityOptionsWithAll,
      "name": "commodity"
    },
    model: {
      value: (_vm.commodity),
      callback: function($$v) {
        _vm.commodity = $$v
      },
      expression: "commodity"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-offset-4 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Date Range")]), _vm._v(" "), _c('date-range', {
    attrs: {
      "name": "date_range"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-load-request"
  }, _vm._l((_vm.loads), function(load) {
    return _c('load-request-item', {
      key: load.id,
      attrs: {
        "load": load
      }
    })
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoLoads),
      expression: "haveNoLoads"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("There are no load requests.")])])]), _vm._v(" "), _c('lazy-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveLoads),
      expression: "haveLoads"
    }],
    ref: "lazyLoading",
    attrs: {
      "reached-bottom": _vm.getLoadsForNextPage,
      "filters": _vm.filters
    }
  }, [_c('strong', {
    staticClass: "text-muted",
    slot: "finished"
  }, [_vm._v("There are no more load requests.")])]), _vm._v(" "), _c('load-request-modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ibox-results-collapse visible-xs",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "href": ".ibox-results-filters-collapse-box",
      "aria-expanded": "false",
      "aria-controls": "ibox-results-filters-collapse-box"
    }
  }, [_vm._v("\n    Show Filters "), _c('i', {
    staticClass: "fa fa-bars"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-46237df0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/Requests.vue
// module id = 983
// module chunks = 0